import PropTypes from "prop-types";
import React from "react";
import {InputLayout} from "./InputLayout";
import {isNumber} from "../../Utilities/Types/typeUtilities";
import {notificationSuffix} from "./Notification";
import {helpTextSuffix} from "./HelpText";

export class InputAdapter extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onInput = this.onInput.bind(this);
    }

    onChange(event) {
        if(this.onChange)
            this.props.onChange(event);
    }

    onInput(event) {
        this.onChange = null;
        this.props.onChange(event);
    }

    render() {
        let {
            disabled,
            helpText,
            inputType,
            label,
            max,
            medium_columns,
            min,
            name,
            placeholder,
            value,
            error,
            responseFeedback,
            showOnlyForSr
        } = this.props;

        if (isNumber(min) && !isNumber(max))
            label = `${label} (minimum: ${min})`;
        if (isNumber(max) && !isNumber(min))
            label = `${label} (maximum: ${max})`;
        if (isNumber(min) && isNumber(max))
            label = `${label} (range: ${min} - ${max})`;

        return (
            <InputLayout
                disabled={disabled}
                helpText={helpText}
                label={label}
                medium_columns={medium_columns}
                name={name}
                error={error}
                responseFeedback={responseFeedback}
                showOnlyForSr={showOnlyForSr}
            >
                <input
                    aria-disabled={disabled}
                    aria-invalid={!!error}
                    aria-errormessage={`${name}${notificationSuffix}`}
                    aria-describedby={`${name}${helpTextSuffix}`}
                    data-testid={name}
                    disabled={disabled}
                    id={name}
                    min={min}
                    max={max}
                    name={name}
                    onChange={this.onChange}
                    onInput={this.onInput}
                    placeholder={placeholder}
                    type={inputType}
                    value={value}
                />
            </InputLayout>
        );
    }
}

export const inputProps = {
    disabled: PropTypes.bool,
    helpText: PropTypes.string,
    label: PropTypes.string.isRequired,
    medium_columns: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    responseFeedback: PropTypes.string,
    showOnlyForSr: PropTypes.bool
};

export const numberProps = {
    ...inputProps,
    max: PropTypes.number,
    min: PropTypes.number,
}

InputAdapter.propTypes = {
    ...numberProps,
    inputType: PropTypes.string,
};

InputAdapter.defaultProps = {
    onChange: () => {
    },
    value: "",
};